import React from "react";
import "../styles/footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <p>Any issues? Contact us at <a href="mailto:hokiehelper@outlook.com" target="_blank" rel="noopener noreferrer">hokiehelper@outlook.com</a>
      </p>
      <p>
        ©2025 Hokie Helper | Michael Bolmer Jr | All Rights
        Reserved
      </p>
    </div>
  );
};

export default Footer;
